<!-- Header CSS -->

<style></style>

<!-- End of header CSS -->

<header class="">
	<div class="container-fluid d-sm-none d-xl-none top-header"></div>
	<div class="container-fluid header-1">
		<div class="row">
			<div class="col-lg-3 col-md-3 col-xs-9">
				<a href="">
					<img src="assets/images/abhi_logo.jpg" class="brand-logo img d-xl-none d-sm-none" />
					<!-- <img src="assets/images/abhi_ipad_logo.png" class="brand-logo img d-xl-none d-sm-block"/>-->
					<img src="assets/images/abhi_mobile_logo.png" class="brand-logo img d-none d-md-block" />
				</a>
				<p></p>
			</div>
			<!-- <div class="col-lg-5 col-md-5 col-xs-9" ng-show="taxImageShow"> 
				<a href="">
					<img src="assets/images/healthbhi-tabhi.png" class="brand-logo img d-xl-none d-sm-none"/>
					 <img src="assets/images/abhi_ipad_logo.png" class="brand-logo img d-xl-none d-sm-block"/>
					<img src="assets/images/abhi_mobile_logo.png" class="brand-logo img visible-xs"/> 	
				</a>
				<p></p>
			</div> -->
		</div>
	</div>

	<div class="container-fluid header-2">
		<div class="row">
			<div class="col-lg-6 col-md-6 col-xs-12 header_pad">
				<!-- (click)="redirectToHealth()" -->
				<span>HEALTH INSURANCE </span>
			</div>
		</div>
	</div>

	<div class="container-fluid header-3">
		<div class="row">
			<div class="col-xs-12 col-md-12 header_pad">
				<span>Aditya Birla Health Insurance Co. Limited</span>
			</div>
		</div>
	</div>
</header>